import axios from "../axios/axios";
import { setCheques } from "../store/actions/chequeAction";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { errorDispatcher, getOptionsQuery, lowerFirst, setSelectItemLabels } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { getQueryParam } from "helpers/queryParam";

const moment = require("moment-jalaali");
export const apiGetCheques =
  ({ pagination, sort, search }) => (dispatch, getState) => {
    const token = getState().businessReducer.business?.token;

    const chequeType = getQueryParam("type")
    let searchText = getQueryParam("status")
    if (chequeType) {
      let slicePosition = chequeType === "receive" ? 15 : 14;
      searchText = typeof searchText === "string" ? lowerFirst(searchText.slice(slicePosition)) : null;
      let url = `/cheques/list?chequeType=${chequeType}`;
            let options = getOptionsQuery(pagination, search, sort);
      if (searchText === "expired") {
        url += "&statusColumn=dueDate";
        url += "&statusText=" + moment().format("jYYYY/jM/jD");
      } else if (searchText !== "all") {
        url += "&statusColumn=status";
        url += "&statusText=" + searchText;
      }

      dispatch(appSetLoading());
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response.data.cheques, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          // dispatch(setCheques(response.data.cheques));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    }
  };
export const apiChequesList = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`/cheques/list/active`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const cheques = setSelectItemLabels(
        response.data.cheques,
        "id",
        (cheque) => `${cheque.personName} - ${cheque.bank ? cheque.bank + " - " : null} ${cheque.dueDate}`
      );
      dispatch(setCheques(cheques));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDeleteCheques = (selectedIds, token) => (dispatch, getState) => {
  dispatch(apiSetAlert("جهت حذف چک لطفا تراکنش مربوطه را حذف نمایید.", "error"));
  // dispatch(appSetLoading());
  // dispatch(appSetSendingRequest());
  // axios
  //     .delete(`/cheques/multiple/delete`, {
  //         headers: {Authorization: `Bearer ${token}`},
  //         data: {chequeIds},
  //     })
  //     .then((response) => {
  //         dispatch(selectTableItems([]));
  //         dispatch(apiSetAlert(response.data.message, "success"));
  //     })
  //     .catch((error) => {
  //         errorDispatcher(error, dispatch)
  //     });
};

// @ts-ignore
export const apiChequeChangeStatus =
  (selectedId, token, status, values, callback) => (dispatch, getState) => {
    dispatch(appSetLoading(true));
    dispatch(appSetSendingRequest(true));

    if (status === "deposit") {
      values = {
        ...values,
        financialId: values.typeId,
      };
    }

    axios
      .put(
        `/chequeAction/${status}/${selectedId}`,
        { ...values },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        // dispatch(selectTableItems([]));
        dispatch(apiSetAlert(response.data.message, "success"));
        dispatch(appSetLoading(false));
        dispatch(appSetSendingRequest(false));
        callback();
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
